/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   Lifestyles bizo
 */

import { MediaType } from '@zcode/enums'
import { Bizo, autoclass } from './base'
import type {
  CityLifestyle as CityLifestyleType,
  CityLifestyles as CityLifestylesType,
  RawCityLifestyle,
  RawCityLifestyles,
  RawTopListable,
  TopListable as TopListableType,
} from './cityLifestyles.types'

export const TopListable: typeof TopListableType = autoclass<TopListableType, RawTopListable>(
  'TopListable',
  class TopListable extends Bizo<TopListableType, RawTopListable> {},
  {
    address: 'address',
    buildingId: (t: TopListableType) => (t.isBuilding ? -t.groupId : null),
    buildingName: 'building_name',
    city: 'city',
    groupId: 'group_id',
    imageIds: 'image_ids',
    images: (t: TopListableType) => {
      if (t?.imageIds?.length) {
        return t.imageIds.map(
          (id) =>
            ({
              id,
              mediaType: MediaType.IMAGE,
            }) as const
        )
      }
      return null
    },
    isActive: (): true => true,
    isBuilding: (t: TopListableType) => t.groupId < 0,
    isShortTermFeed: (): false => false,
    isShortTermViewV1: (): false => false,
    lat: 'lat',
    listingId: (t: TopListableType) => (t.isBuilding ? null : t.groupId),
    lng: 'lng',
    neighborhoodName: 'neighborhood_name',
    paShouldIndex: 'pa_should_index',
    paUrl: 'pa_url',
    state: 'state',
    status: () => 1,
    url: 'url',
  }
)

export const CityLifestyle: typeof CityLifestyleType = autoclass<
  CityLifestyleType,
  RawCityLifestyle
>('CityLifestyle', class CityLifestyle extends Bizo<CityLifestyleType, RawCityLifestyle> {}, {
  feature: 'feature',
  topHoods: 'top_hoods',
  topListable: {
    name: 'top_listable',
    type: TopListable,
  },
})

export const CityLifestyles: typeof CityLifestylesType = autoclass<
  CityLifestylesType,
  RawCityLifestyles
>('CityLifestyles', class CityLifestyles extends Bizo<CityLifestylesType, RawCityLifestyles> {}, {
  lifestyles: {
    isArray: true,
    name: 'lifestyles',
    type: CityLifestyle,
  },
  affordable: 'affordable',
  popular: 'popular',
})

export type CityLifestyles = CityLifestylesType
export type CityLifestyle = CityLifestyleType
export type TopListable = TopListableType
